import { render, staticRenderFns } from "./WelcomeOfferEditor.vue?vue&type=template&id=2dbf2513&"
import script from "./WelcomeOfferEditor.vue?vue&type=script&lang=js&"
export * from "./WelcomeOfferEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports